"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrabGeolocationProvider = void 0;
const distance_1 = require("@turf/distance");
const GeocodingProvider_1 = require("./GeocodingProvider");
class CrabGeolocationProvider extends GeocodingProvider_1.default {
    constructor(bounds) {
        super("crab");
        this.apiRoot = "https://geo.api.vlaanderen.be/geolocation/v4/";
    }
    forward(query, callback) {
        if (typeof query.string === "undefined")
            return;
        // REMARK; this is weird right, but CRAB returns communes when searching for kerk instead of streets.
        if (query.string.toLowerCase() === "kerk") {
            query.string = "kerkstraat";
        }
        const xhr = new XMLHttpRequest();
        xhr.open("GET", `${this, this.apiRoot}/Location?q=${query.string}&c=5`);
        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                if (response.LocationResult) {
                    const results = [];
                    response.LocationResult.forEach(l => {
                        let score = 50;
                        let type = "commune";
                        if (l.LocationType == "crab_straat") {
                            type = "street";
                            score = 70;
                        }
                        else if (l.LocationType.startsWith("crab_huisnummer")) {
                            type = "address";
                            score = 90;
                        }
                        const lon = l.Location.Lon_WGS84;
                        const lat = l.Location.Lat_WGS84;
                        // check bounds, if outside, don't return as result.
                        if (typeof this.bounds !== "undefined") {
                            if (this.bounds[0] > lon)
                                return;
                            if (this.bounds[2] < lon)
                                return;
                            if (this.bounds[1] > lat)
                                return;
                            if (this.bounds[3] < lat)
                                return;
                        }
                        results.push({
                            description: l.FormattedAddress,
                            location: {
                                lng: lon,
                                lat: lat
                            },
                            type: type,
                            score: score,
                            provider: this.name,
                            raw: l
                        });
                    });
                    callback(results);
                }
            }
            else {
                console.log("geocode failed: " + xhr.status);
            }
        };
        xhr.send();
    }
    reverse(l, callback) {
        if (!l)
            return callback([]);
        const xhr = new XMLHttpRequest();
        xhr.open("GET", `${this.apiRoot}/Location?q=${l.lat},${l.lng}&c=1`);
        xhr.onload = () => {
            if (xhr.status === 200) {
                const response = JSON.parse(xhr.responseText);
                if (response.LocationResult) {
                    const results = [];
                    response.LocationResult.forEach(lr => {
                        results.push({
                            description: lr.FormattedAddress,
                            location: {
                                lng: lr.Location.Lon_WGS84,
                                lat: lr.Location.Lat_WGS84
                            },
                            distance: distance_1.default([l.lng, l.lat], [lr.Location.Lon_WGS84, lr.Location.Lat_WGS84]) * 1000
                        });
                    });
                    callback(results);
                }
            }
            else {
                console.log("reverseGeocode failed: " + xhr.status);
            }
        };
        xhr.send();
    }
}
exports.CrabGeolocationProvider = CrabGeolocationProvider;
